import BaseScene from './BaseScene'
import { ScorerSpeed, WalkSpeed, BrownianSpeed } from './Constants'
import { delay } from '../helper'
import * as sounds from '../../../constants/Sounds'

export default class EndGame extends BaseScene {
    constructor(event, pitch) {
        super(pitch);

        let keyPoints = pitch.getKeyPoints(true);

        this.CenterPoint = keyPoints.center;
        this.HomeExit = keyPoints.exit;
        this.HomeSubstitutionPoint = keyPoints.substitutionPoint;
        this.AwayExit = pitch.getKeyPoints(false).exit;
        this.AwaySubstitutionPoint = pitch.getKeyPoints(false).substitutionPoint;
    }

    Play(gameSpeed) {
        return new Promise(function(resolve, reject) {
            
            this.SoundManager.play(sounds.GAME_END);
            
            this.getPlayersByTeam(true)
                .forEach((player) => player.MoveToWithSpeed(gameSpeed, WalkSpeed, this.HomeSubstitutionPoint)
                .then(()=> player.MoveToWithSpeed(gameSpeed, WalkSpeed, this.HomeExit)));

            this.getPlayersByTeam(false)
                .forEach((player) => player.MoveToWithSpeed(gameSpeed, WalkSpeed, this.AwaySubstitutionPoint)
                .then(()=> player.MoveToWithSpeed(gameSpeed, WalkSpeed, this.AwayExit)));
            
            let referee = this.Pitch.referee.getWrappedInstance();
            let leftLinesman = this.Pitch.homeLinesman;
            let rightLinesman = this.Pitch.awayLinesman;

            [referee, leftLinesman, this.Pitch.homeManager]
                .forEach((ref) => ref.MoveToWithSpeed(gameSpeed, WalkSpeed, this.HomeSubstitutionPoint)
                        .then(()=> ref.MoveToWithSpeed(gameSpeed, WalkSpeed, this.HomeExit)));

            [rightLinesman, this.Pitch.awayManager].forEach((ref) => ref.MoveToWithSpeed(gameSpeed, WalkSpeed, this.AwaySubstitutionPoint)
                .then(()=> ref.MoveToWithSpeed(gameSpeed, WalkSpeed, this.AwayExit)));
            
        }.bind(this));
    }
}



/** WEBPACK FOOTER **
 ** ./src/components/Animations/Scenes/EndGame.js
 **/